import { useEffect } from 'react';

// Every popup darkens the page with this overlay (see the modals' .module.scss)
const OVERLAY_RGB = '100, 100, 100';
const OVERLAY_ALPHA = 0.3;

let openOverlays = 0;

/**
 * The page's scrollbar sits outside the popups' overlays, so its track is tinted to match them
 * (App.css): clear with no popup, and darker for each popup stacked on top of another.
 */
const updatePageScrollbar = () => {
  const root = document.documentElement;
  // n overlays of the same colour stacked make one with alpha 1 - (1 - a)^n
  const alpha = 1 - Math.pow(1 - OVERLAY_ALPHA, openOverlays);
  root.style.setProperty('--page-scrollbar-track', openOverlays > 0 ? `rgba(${OVERLAY_RGB}, ${alpha.toFixed(3)})` : 'transparent');
  root.classList.toggle('OverlayOpen', openOverlays > 0);
};

/** Call in a popup with whether it's showing, so the page's scrollbar matches its overlay. */
export const useOverlay = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) return;
    openOverlays += 1;
    updatePageScrollbar();
    return () => {
      openOverlays -= 1;
      updatePageScrollbar();
    };
  }, [isOpen]);
};
